import { Route } from '@angular/router';
import { WORD_STUDY_PAGE_LINKS, WORD_STUDY_PAGE_MEDIA_ID } from '../dashboards.constants';
import { createRequiredPlanGuard } from '@lib/frontend-shared-data-permissions-service';
import { SchoolAccountPlan } from '@lib/shared-interface-account';

const isPremiumOrFullAccess = createRequiredPlanGuard([
    SchoolAccountPlan.PREMIUM,
    SchoolAccountPlan.FULL_ACCESS,
]);

export const WORD_STUDY_PROGRAM_ROUTES: Route[] = [
    {
        path: 'word-study-program',
        title: 'The EB Word Study Program',
        canMatch: [isPremiumOrFullAccess],
        loadComponent: () => import('../dashboard-template.page'),
        data: {
            mediaId: WORD_STUDY_PAGE_MEDIA_ID,
            links: WORD_STUDY_PAGE_LINKS,
        },
    },
    {
        path: 'word-study-program/introductory-unit',
        title: 'The EB Word Study Program',
        canMatch: [isPremiumOrFullAccess],
        loadComponent: () =>
            import('../word-study-program/introductory-unit/introductory-unit.page'),
        data: {
            backUrl: '../',
            forwardUrl: '../grade-level-lessons',
        },
    },
    {
        path: 'word-study-program/grade-level-lessons',
        title: 'The EB Word Study Program',
        canMatch: [isPremiumOrFullAccess],
        loadComponent: () =>
            import('../word-study-program/grade-level-lessons-page/grade-level-lessons.page'),
        data: {
            backUrl: '../introductory-unit',
        },
    },
];
